import { useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const LEADERSHIP = ["admin", "ceo", "director"];

// Owner filter for leadership: "Todos" / "Solo míos" / a specific user.
// Regular users are not leadership, so the filter is hidden and filtering is a no-op.
export function useTeamFilter() {
  const { user } = useAuth();
  const isLeader = LEADERSHIP.includes(user?.role);
  const [members, setMembers] = useState([]);
  const [ownerId, setOwnerId] = useState("");

  useEffect(() => {
    if (isLeader) api.get("/auth/team").then((r) => setMembers(r.data)).catch(() => {});
  }, [isLeader]);

  const filter = useCallback(
    (arr) => (!ownerId || !Array.isArray(arr) ? arr : arr.filter((x) => x.owner_id === ownerId)),
    [ownerId]
  );

  return { members, ownerId, setOwnerId, isLeader, filter, currentUserId: user?.id };
}
